import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _AddContentButton;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { IconPlusLine } from '@instructure/ui-icons';
import { PresentationContent, ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Button } from '@instructure/ui-buttons';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/es/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { END_EDITING_TRIGGER_CLASSNAME, withStyleOverrides } from '@instructure/quiz-common';
export var AddContentButton = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_AddContentButton = /*#__PURE__*/function (_Component) {
  function AddContentButton() {
    var _this;
    _classCallCheck(this, AddContentButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AddContentButton, [].concat(args));
    _defineProperty(_this, "storeButtonElemRef", function (c) {
      _this.buttonElem = c;
    });
    return _this;
  }
  _inherits(AddContentButton, _Component);
  return _createClass(AddContentButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.buttonElem.focus();
    }
  }, {
    key: "renderStimulus",
    value: function renderStimulus() {
      return jsx("div", {
        css: this.props.styles.attachQuestionButtonHolder
      }, jsx(Button, {
        ref: this.storeButtonElemRef,
        color: "primary",
        margin: "medium",
        onClick: this.props.onClick,
        "data-automation": "sdk-attach-question-button"
      }, t('Attach Question')));
    }
  }, {
    key: "renderNonStimulus",
    value: function renderNonStimulus() {
      return jsx("div", {
        className: END_EDITING_TRIGGER_CLASSNAME,
        css: this.props.styles.newItemButtonHolder
      }, jsx("button", {
        ref: this.storeButtonElemRef,
        onClick: this.props.onClick,
        css: this.props.styles.newItemButton,
        className: this.props.position !== null ? "newItemButton_".concat(this.props.position) : null,
        "data-automation": "sdk-add-content-button",
        "aria-expanded": this.props.isEditing
      }, jsx(ScreenReaderContent, null, t('Add Content')), jsx(PresentationContent, null, jsx(IconPlusLine, {
        title: t('Add Content')
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.useStimulusTrigger ? this.renderStimulus() : this.renderNonStimulus();
    }
  }]);
}(Component), _defineProperty(_AddContentButton, "displayName", 'AddContentButton'), _defineProperty(_AddContentButton, "componentId", "Quizzes".concat(_AddContentButton.displayName)), _defineProperty(_AddContentButton, "propTypes", {
  isEditing: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  position: PropTypes.number,
  useStimulusTrigger: PropTypes.bool.isRequired,
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _defineProperty(_AddContentButton, "defaultProps", {
  onClick: Function.prototype,
  position: null
}), _AddContentButton)) || _class);
export default AddContentButton;